import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import Spinner from '@tds/core-spinner';
import Switch from 'react-switch';

import request from '../../../../../../../../../../utils/request';
import {
  FormControl,
  FormControlLabel,
  EditOverlay,
  ErrorMessage
} from '../../../../css';

const FormControlItem = ({ id, formTypes, data, isDeleted, fetchData }) => {
  const { key, label } = data;
  const [isActive, setIsActive] = useState(false);
  const [error, setError] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const updateAccess = async () => {
    setIsUpdating(true);
    setIsActive(!isActive);
    try {
      const result = await request.put('/disable-form-access-for-channel', {
        channelId: id,
        forms: {
          ...formTypes,
          [key]: isActive
        }
      });
      if (result && result.status === 200) {
        fetchData();
        setTimeout(() => setIsUpdating(false), 1500);
      }
    } catch (err) {
      setIsUpdating(false);
      setError(true);
      setTimeout(() => setError(false), 4000);
      throw err;
    }
  };

  useEffect(() => {
    setIsActive(!isDeleted && !_.get(formTypes, key, false));
  }, [isDeleted]);

  return (
    <>
      <FormControl>
        <FormControlLabel isActive={isActive}>{label}</FormControlLabel>
        <Switch
          onColor="#4B286D"
          onChange={updateAccess}
          checked={isActive}
          disabled={isDeleted}
        />
      </FormControl>
      {error && <ErrorMessage>Error occurred while updating</ErrorMessage>}
      {isUpdating && (
        <EditOverlay>
          <Spinner label="Updating..." spinning={isUpdating}></Spinner>
        </EditOverlay>
      )}
    </>
  );
};

FormControlItem.propTypes = {
  data: PropTypes.shape({ key: PropTypes.number, label: PropTypes.string })
    .isRequired,
  id: PropTypes.number.isRequired,
  formTypes: PropTypes.shape({
    disableBrp: PropTypes.bool,
    disableReferral: PropTypes.bool,
    disableWireless: PropTypes.bool,
    disableWireline: PropTypes.bool
  }).isRequired,
  isDeleted: PropTypes.bool.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default FormControlItem;
